import { StatusChip } from "../common/StatusChip";
import {
  DELIVERY_TYPE_LABELS,
  PAYMENT_METHOD_LABELS,
  PAYMENT_PROVIDER_LABELS,
} from "../../utils/orderConstants";
import { formatDate } from "../../utils/formatDate";
import { PAYMENT_CHANNEL_CONFIG } from "./order.columns";

const Row = ({ label, children }) => (
  <div className="ui-kv__row">
    <span className="ui-kv__label">{label}</span>
    <span className="ui-kv__value">{children}</span>
  </div>
);

export const CardSummaryOrder = ({ order }) => {
  if (!order) return null;

  const productCount = order.items?.reduce((sum, item) => sum + (item.quantity || 0), 0) || 0;
  const subtotal = order.subtotal || 0;
  const commission = order.comission?.value || 0;
  const percentage = order.comission?.percentage || 0;
  const total = order.total || 0;
  const points = order.items?.reduce((acc, item) => acc + item.loyalty_points * item.quantity, 0) || 0;

  return (
    <div className="ui-card">
      <h3 style={{ margin: "0 0 16px", fontSize: 15, fontWeight: 700 }}>Resumen</h3>

      <div className="ui-kv">
        <Row label="Fecha de creación">{formatDate(order.created_at)}</Row>

        {order.payment_paid_approval && (
          <Row label="Fecha de pago">{formatDate(order.payment_paid_approval)}</Row>
        )}

        <Row label="Estado de la transacción">
          {order.payment_response
            ? order.payment_response?.data?.transaction?.status === "APPROVED"
              ? "Aprobado"
              : "Rechazado"
            : "Pendiente"}
        </Row>

        <Row label="Tipo de entrega">{DELIVERY_TYPE_LABELS[order.delivery_type] || order.delivery_type}</Row>
        <Row label="Productos">{productCount}</Row>

        {order.delivery_type === "DELIVERY" && order.shipping_cost ? (
          <Row label="Costo de envío">${order.shipping_cost.toLocaleString()}</Row>
        ) : null}

        <Row label="Subtotal">${subtotal.toLocaleString()}</Row>
        <Row label={`Servicio On Line (${percentage.toLocaleString()}%)`}>${commission.toLocaleString()}</Row>

        {order.payment_channel === "card_payment" && <Row label="Servicio On Line">$500</Row>}

        <Row label="Método de pago">
          {PAYMENT_METHOD_LABELS[order.payment_method] || order.payment_method}
          {order.payment_provider && ` (${PAYMENT_PROVIDER_LABELS[order.payment_provider] || order.payment_provider})`}
          {order.payment_provider === "MONNET" && order.payment_channel &&
            ` - ${PAYMENT_CHANNEL_CONFIG[order.payment_channel]?.label || order.payment_channel}`}
        </Row>

        {order.payment_provider && (
          <Row label="Proveedor">{PAYMENT_PROVIDER_LABELS[order.payment_provider]}</Row>
        )}

        {order.payment_response?.data?.transaction?.id && (
          <Row label="Referencia Wompi">
            <span className="ui-kv__value--mono">{order.payment_response.data.transaction.id}</span>
          </Row>
        )}

        {order.delivered_at && (
          <Row label="Fecha de entrega">
            <StatusChip tone="success" icon="ri-checkbox-circle-line" sm>
              {formatDate(order.delivered_at)}
            </StatusChip>
          </Row>
        )}

        {order.cancel_reason && (
          <Row label="Motivo de cancelación">
            <span style={{ color: "#DC2626" }}>{order.cancel_reason}</span>
          </Row>
        )}

        {order.cancelled_at && <Row label="Fecha de cancelación">{formatDate(order.cancelled_at)}</Row>}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          marginTop: 14,
          paddingTop: 14,
          borderTop: "1px solid #EDEFF6",
        }}
      >
        <span style={{ fontSize: 13.5, fontWeight: 700 }}>Total</span>
        <span style={{ fontSize: 24, fontWeight: 800, letterSpacing: "-0.025em" }}>
          ${total.toLocaleString()}
        </span>
      </div>

      <div
        style={{
          background: "#FAFAFF",
          border: "1px solid #EDEFF6",
          borderRadius: 10,
          padding: "11px 13px",
          marginTop: 14,
          display: "flex",
          justifyContent: "space-between",
          fontSize: 12.5,
        }}
      >
        <span style={{ color: "#5A6187" }}>Puntos generados</span>
        <span style={{ fontWeight: 700, color: "#4B36F0" }}>{points} pts</span>
      </div>
    </div>
  );
};
